// extracted by mini-css-extract-plugin
export default {"menuBlock":"aH-z","title":"bH-z","nav":"cH-z","flexCell":"dH-z","facetLink":"eH-z"};